module.exports = __webpack_public_path__ + "static/media/Polarizer_Icon.0599b7b7.svg";